import { render, staticRenderFns } from "./PreventIntegrationsView.vue?vue&type=template&id=5624c628&scoped=true&"
import script from "./PreventIntegrationsView.vue?vue&type=script&lang=js&"
export * from "./PreventIntegrationsView.vue?vue&type=script&lang=js&"
import style0 from "./PreventIntegrationsView.vue?vue&type=style&index=0&id=5624c628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624c628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VCol,VDataTable,VDivider,VIcon,VRow,VSimpleTable})
